import React from 'react';
import { Form } from 'react-bootstrap';

const OPTIONS = [
  { value: '00', label: 'Entrada com recuperação de crédito' },
  { value: '49', label: 'Outras entradas' },
  { value: '50', label: 'Saída tributada' },
  { value: '51', label: 'Saída tributada c/ alíquota zero' },
  { value: '52', label: 'Saída isenta' },
  { value: '53', label: 'Saída não tributada' },
  { value: '54', label: 'Saída imune' },
  { value: '55', label: 'Saída c/ suspensão' },
  { value: '99', label: 'Outras saídas' },
];

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  isInvalid?: boolean;
}

const SelectCSTIPI = React.forwardRef<HTMLSelectElement, Props & Omit<React.ComponentPropsWithoutRef<'select'>, 'onChange' | 'value' | 'size'>>(
  ({ value, onChange, disabled, size, isInvalid, ...rest }, ref) => (
    <Form.Select
      ref={ref}
      size={size}
      value={value ?? ''}
      onChange={e => onChange?.(e.target.value)}
      disabled={disabled}
      isInvalid={isInvalid}
      aria-label="CST IPI"
      {...rest}
    >
      <option value="">CST IPI...</option>
      {OPTIONS.map(o => (
        <option key={o.value} value={o.value}>{o.value} — {o.label}</option>
      ))}
    </Form.Select>
  )
);

SelectCSTIPI.displayName = 'SelectCSTIPI';

export default SelectCSTIPI;
